module.exports = __webpack_public_path__ + "img/403.45878d43.svg";